:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._cur-pointer{cursor:pointer;}
:root ._pos-relative{position:relative;}
:root ._pr-t-space-lar3294{padding-right:var(--t-space-large);}
:root ._pl-t-space-lar3294{padding-left:var(--t-space-large);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
@media (min-width: 601px){:root:root:root:root:root ._pr-_gtSm_0px{padding-right:0px;}}
@media (min-width: 601px){:root:root:root:root:root ._pl-_gtSm_0px{padding-left:0px;}}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._pt-t-space-lar102228{padding-top:var(--t-space-larger);}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._pb-t-space-lar102228{padding-bottom:var(--t-space-larger);}
:root ._width-10037{width:100%;}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}
:root ._maxW-600px{max-width:600px;}
:root ._self-center{align-self:center;}